import React, { useState } from "react";
import axios from "axios";
import {
  Box, Button, TextField, Typography, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper,
  CircularProgress, Card, Backdrop
} from "@mui/material";
import { BASE_URL } from "../../App";
import Swal from 'sweetalert2';

//const loginid = localStorage.getItem("loginid");

const ServiceCallCancellation = () => {
  const [tokenNumber, setTokenNumber] = useState("");
  const [reason, setReason] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDetails = async () => {
    
    const loginid = localStorage.getItem("LOGIN_ID");
    if (!tokenNumber) {
      Swal.fire("Error", "Please enter a token number.", "error");
      return;
    }

    setLoading(true);
    setData([]);

    try {
      const response = await axios.post(`${BASE_URL}/fetchTokenDetails`, {
        token: tokenNumber,
        loginid: loginid,
      });
      if (response.data?.details?.length > 0) {
        setData(response.data.details);
      } else {
        Swal.fire("No Record", "No record found.", "warning");
      }
    } catch {
      Swal.fire("info", "Only the creator can request cancellation.", "info");
    } finally {
      setLoading(false);
    }
  };

  const requestCancellation = async () => {
    const loginid = localStorage.getItem("LOGIN_ID");
  
    if (!reason.trim()) {
      Swal.fire("Error", "Please enter a reason.", "error");
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await axios.post(`${BASE_URL}/requestCancellation`, {
        token: tokenNumber,
        reason,
        loginid: loginid,
      });
  
      // Logging response for debugging
      console.log("Cancellation Response:", response.data);
  
      if (response.status === 200 && response.data?.success) {
        Swal.fire("Success", response.data.message || "Cancellation request submitted successfully.", "success");
        setData([]);
        setReason("");
      } else {
        Swal.fire("success", response.data?.error || "Cancellation request submitted successfully.", "success");
      }
    } catch (error) {
      console.error("Cancellation Error:", error);
      if (error.response?.data?.error) {
        Swal.fire("Info", error.response.data.error, "info");
      } else {
        Swal.fire("Error", "Cancellation request failed. Try again.", "error");
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Box p={4}>
      <Card sx={{ p: 4, borderRadius: 3, boxShadow: 4 }}>
        <Typography variant="h5" gutterBottom>
          Service Call Cancellation
        </Typography>

        <Box display="flex" alignItems="center" gap={2} mb={3}>
          <TextField
            label="Token Number"
            variant="outlined"
            value={tokenNumber}
            onChange={(e) => setTokenNumber(e.target.value)}
          />
          <Button variant="contained" onClick={fetchDetails}>
            Get Details
          </Button>
        </Box>

        {/* Full-screen loader */}
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {data.length > 0 && (
          <>
            <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                    <TableCell><strong>Token Number</strong></TableCell>
                    <TableCell><strong>Serial No</strong></TableCell>
                    <TableCell><strong>Item Code</strong></TableCell>
                    <TableCell><strong>Created By</strong></TableCell>
                    <TableCell><strong>Assigned To</strong></TableCell>
                    <TableCell><strong>Mobile No</strong></TableCell>
                    <TableCell><strong>Customer Details</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{item.TOKEN_NO}</TableCell>
                      <TableCell>{item.SERIALNO}</TableCell>
                      <TableCell>{item.ITEMCODE?.trim()}</TableCell>
                      <TableCell>{item.CREATEDBY}</TableCell>
                      <TableCell>{item.ASSIGNEDTO}</TableCell>
                      <TableCell>{item.MOBILENO}</TableCell>
                      <TableCell>{item.CUSTOMERDETAILS}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box mt={3} display="flex" alignItems="center" gap={2}>
              <TextField
                label="Reason"
                variant="outlined"
                fullWidth
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
              <Button variant="contained" color="error" onClick={requestCancellation}>
                Request
              </Button>
            </Box>
          </>
        )}
      </Card>
    </Box>
  );
};

export default ServiceCallCancellation;
